// costCenterRules.js


// ===================== TEMPE =====================
export const COST_CENTER_RULES = [
  // --- TA ---
  { position: "TA", location: "TEMPE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG02202" },
  { position: "TA", location: "TEMPE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06875" },
  { position: "TA", location: "ICOURSE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "TA", location: "ICOURSE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06316" },
  { position: "TA", location: "ASUONLINE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "TA", location: "ASUONLINE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06316" },

  // --- IA ---
  { position: "IA", location: "TEMPE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG15818" },
  { position: "IA", location: "TEMPE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG15818" },
  { position: "IA", location: "ICOURSE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "IA", location: "ICOURSE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG01943" },
  { position: "IA", location: "ASUONLINE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "IA", location: "ASUONLINE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG01943" },

  // --- Grader ---
  { position: "Grader", location: "TEMPE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG14700" },
  { position: "Grader", location: "TEMPE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG14700" },
  { position: "Grader", location: "ICOURSE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "Grader", location: "ICOURSE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06316" },
  { position: "Grader", location: "ASUONLINE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "Grader", location: "ASUONLINE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06316" },
  { position: "Grader", location: "WEST", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG14700" },

  // --- TA (GSA) 1 credit ---
  { position: "TA (GSA) 1 credit", location: "TEMPE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG02202" },
  { position: "TA (GSA) 1 credit", location: "TEMPE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06875" },
  { position: "TA (GSA) 1 credit", location: "ICOURSE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "TA (GSA) 1 credit", location: "ICOURSE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06316" },
  { position: "TA (GSA) 1 credit", location: "ASUONLINE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "TA (GSA) 1 credit", location: "ASUONLINE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06316" },

  // --- TA (GSA) 1 credit + ---
  { position: "TA (GSA) 1 credit +", location: "TEMPE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG02202" },
  { position: "TA (GSA) 1 credit +", location: "TEMPE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06875" },
  { position: "TA (GSA) 1 credit +", location: "ICOURSE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "TA (GSA) 1 credit +", location: "ICOURSE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06316" },
  { position: "TA (GSA) 1 credit +", location: "ASUONLINE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "TA (GSA) 1 credit +", location: "ASUONLINE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06316" },


  // --- IOR ---
  { position: "IOR", location: "TEMPE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG02202" },
  { position: "IOR", location: "TEMPE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06875" },
  { position: "IOR", location: "ICOURSE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "IOR", location: "ICOURSE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06316" },
  { position: "IOR", location: "ASUONLINE", campus: "TEMPE", acadCareer: "UGRD", costCenterKey: "CC0136/PG01943" },
  { position: "IOR", location: "ASUONLINE", campus: "TEMPE", acadCareer: "GRAD", costCenterKey: "CC0136/PG06316" },

  // ===================== POLY =====================

  // --- TA ---
  { position: "TA", location: "POLY", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02202" },
  { position: "TA", location: "POLY", campus: "POLY", acadCareer: "GRAD", costCenterKey: "CC0136/PG06875" },
  { position: "TA", location: "ICOURSE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  { position: "TA", location: "ASUONLINE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  // (ICOURSE, POLY, GRAD) = '-' → omit

  // --- IA ---
  { position: "IA", location: "POLY", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG15818" },
  { position: "IA", location: "POLY", campus: "POLY", acadCareer: "GRAD", costCenterKey: "CC0136/PG15818" },
  { position: "IA", location: "ICOURSE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  { position: "IA", location: "ICOURSE", campus: "POLY", acadCareer: "GRAD", costCenterKey: "CC0136/PG02003" },
  { position: "IA", location: "ASUONLINE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  { position: "IA", location: "ASUONLINE", campus: "POLY", acadCareer: "GRAD", costCenterKey: "CC0136/PG02003" },


  // --- Grader ---
  { position: "Grader", location: "POLY", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG14700" },
  { position: "Grader", location: "POLY", campus: "POLY", acadCareer: "GRAD", costCenterKey: "CC0136/PG14700" },
  { position: "Grader", location: "ICOURSE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  { position: "Grader", location: "ASUONLINE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  // (ICOURSE, POLY, GRAD) = '-' → omit

  // --- TA (GSA) 1 credit ---
  { position: "TA (GSA) 1 credit", location: "POLY", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02202" },
  { position: "TA (GSA) 1 credit", location: "POLY", campus: "POLY", acadCareer: "GRAD", costCenterKey: "CC0136/PG06875" },
  { position: "TA (GSA) 1 credit", location: "ICOURSE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  { position: "TA (GSA) 1 credit", location: "ASUONLINE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  // (ICOURSE, POLY, GRAD) = '-' → omit

  // --- TA (GSA) 1 credit + ---
  { position: "TA (GSA) 1 credit +", location: "POLY", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02202" },
  { position: "TA (GSA) 1 credit +", location: "POLY", campus: "POLY", acadCareer: "GRAD", costCenterKey: "CC0136/PG06875" },
  { position: "TA (GSA) 1 credit +", location: "ICOURSE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  { position: "TA (GSA) 1 credit +", location: "ASUONLINE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  // (ICOURSE, POLY, GRAD) = '-' → omit

  // --- IOR ---
  { position: "IOR", location: "POLY", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02202" },
  { position: "IOR", location: "POLY", campus: "POLY", acadCareer: "GRAD", costCenterKey: "CC0136/PG06875" },
  { position: "IOR", location: "ICOURSE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  { position: "IOR", location: "ASUONLINE", campus: "POLY", acadCareer: "UGRD", costCenterKey: "CC0136/PG02003" },
  // (ICOURSE, POLY, GRAD) = '-' → omit

  // ===================== WEST =====================
  // --- Grader ---
  { position: "Grader", location: "WEST", campus: "WEST", acadCareer: "UGRD", costCenterKey: "CC0136/PG14700" },

];

// ===================== SUMMER (terms ending in 4) =====================
// Career (UGRD/GRAD) does NOT matter — only Position + Delivery (Ground/Online) + Campus
export const SUMMER_COST_CENTER_RULES = [
  // ===== TEMPE =====
  // TA — Ground
  { position: "TA", location: "TEMPE", campus: "TEMPE", costCenterKey: "CC1139/PG08491 + DR08243" },
  // TA — Online
  { position: "TA", location: "ASUONLINE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },
  { position: "TA", location: "ICOURSE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },

  // IOR — Ground
  { position: "IOR", location: "TEMPE", campus: "TEMPE", costCenterKey: "CC1139/PG08491 + DR08243" },
  // IOR — Online
  { position: "IOR", location: "ASUONLINE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },
  { position: "IOR", location: "ICOURSE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },

  // IA — Ground
  { position: "IA", location: "TEMPE", campus: "TEMPE", costCenterKey: "CC1139/PG08491 + DR08243" },
  // IA — Online
  { position: "IA", location: "ASUONLINE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },
  { position: "IA", location: "ICOURSE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },

  // Grader — Ground
  { position: "Grader", location: "TEMPE", campus: "TEMPE", costCenterKey: "CC1139/PG08491 + DR08243" },
  // Grader — Online
  { position: "Grader", location: "ASUONLINE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },
  { position: "Grader", location: "ICOURSE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },

  // TA (GSA) 1 credit — Ground
  { position: "TA (GSA) 1 credit", location: "TEMPE", campus: "TEMPE", costCenterKey: "CC1139/PG08491 + DR08243" },
  // TA (GSA) 1 credit — Online
  { position: "TA (GSA) 1 credit", location: "ASUONLINE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },
  { position: "TA (GSA) 1 credit", location: "ICOURSE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },

  // TA (GSA) 1 credit + — Ground
  { position: "TA (GSA) 1 credit +", location: "TEMPE", campus: "TEMPE", costCenterKey: "CC1139/PG08491 + DR08243" },
  // TA (GSA) 1 credit + — Online
  { position: "TA (GSA) 1 credit +", location: "ASUONLINE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },
  { position: "TA (GSA) 1 credit +", location: "ICOURSE", campus: "TEMPE", costCenterKey: "CC0136/PG01943" },

  // ===== POLY =====
  // TA — Ground
  { position: "TA", location: "POLY", campus: "POLY", costCenterKey: "CC1139/PG08524 + DR08243" },
  // TA — Online
  { position: "TA", location: "ASUONLINE", campus: "POLY", costCenterKey: "CC0136/PG02003" },
  { position: "TA", location: "ICOURSE", campus: "POLY", costCenterKey: "CC0136/PG02003" },

  // IOR — Ground
  { position: "IOR", location: "POLY", campus: "POLY", costCenterKey: "CC1139/PG08524 + DR08243" },
  // IOR — Online
  { position: "IOR", location: "ASUONLINE", campus: "POLY", costCenterKey: "CC0136/PG02003" },
  { position: "IOR", location: "ICOURSE", campus: "POLY", costCenterKey: "CC0136/PG02003" },

  // IA — Ground
  { position: "IA", location: "POLY", campus: "POLY", costCenterKey: "CC1139/PG08524 + DR08243" },
  // IA — Online
  { position: "IA", location: "ASUONLINE", campus: "POLY", costCenterKey: "CC0136/PG02003" },
  { position: "IA", location: "ICOURSE", campus: "POLY", costCenterKey: "CC0136/PG02003" },

  // Grader — Ground
  { position: "Grader", location: "POLY", campus: "POLY", costCenterKey: "CC1139/PG08524 + DR08243" },
  // Grader — Online
  { position: "Grader", location: "ASUONLINE", campus: "POLY", costCenterKey: "CC0136/PG02003" },
  { position: "Grader", location: "ICOURSE", campus: "POLY", costCenterKey: "CC0136/PG02003" },

  // TA (GSA) 1 credit — Ground
  { position: "TA (GSA) 1 credit", location: "POLY", campus: "POLY", costCenterKey: "CC1139/PG08524 + DR08243" },
  // TA (GSA) 1 credit — Online
  { position: "TA (GSA) 1 credit", location: "ASUONLINE", campus: "POLY", costCenterKey: "CC0136/PG02003" },
  { position: "TA (GSA) 1 credit", location: "ICOURSE", campus: "POLY", costCenterKey: "CC0136/PG02003" },

  // TA (GSA) 1 credit + — Ground
  { position: "TA (GSA) 1 credit +", location: "POLY", campus: "POLY", costCenterKey: "CC1139/PG08524 + DR08243" },
  // TA (GSA) 1 credit + — Online
  { position: "TA (GSA) 1 credit +", location: "ASUONLINE", campus: "POLY", costCenterKey: "CC0136/PG02003" },
  { position: "TA (GSA) 1 credit +", location: "ICOURSE", campus: "POLY", costCenterKey: "CC0136/PG02003" },
];


function norm(s) {
  return String(s ?? "")
    .normalize("NFKC")          // normalize unicode forms
    .replace(/\u00A0/g, " ")    // NBSP -> space
    .replace(/\s+/g, " ")       // collapse multiple spaces
    .toUpperCase()
    .trim();
}

// --- Util: Compute Cost Center Key ---
// Pass term (e.g. "2264") to use summer rules when term ends in 4
export function computeCostCenterKey(position, location, campus, acadCareer, term) {
  const pos  = norm(position);
  const loc  = norm(location);
  const camp = norm(campus);

  // Summer terms (ending in 4) — career doesn't matter
  if (term && String(term).endsWith("4")) {
    const rule = SUMMER_COST_CENTER_RULES.find(r =>
      norm(r.position) === pos &&
      norm(r.location) === loc &&
      norm(r.campus)   === camp
    );
    return rule ? rule.costCenterKey : "UNKNOWN";
  }

  // Spring (1) / Fall (7) — career matters
  const career = norm(acadCareer);
  const rule = COST_CENTER_RULES.find(r =>
    norm(r.position)   === pos &&
    norm(r.location)   === loc &&
    norm(r.campus)     === camp &&
    norm(r.acadCareer) === career
  );

  return rule ? rule.costCenterKey : "UNKNOWN";
}